import { useContext } from 'react';
import { UserPreferencesContext, UserPreferencesContextType } from '../user-preferences.context';

export const useUserPreferencesContext = (): UserPreferencesContextType =>
    useContext<UserPreferencesContextType>(UserPreferencesContext);
